import styled from 'styled-components';

const CommunicationGoalsTable = styled.div`

  .multiple-ripple-preloader {
    margin: 5em auto;
    width: 80px;
    height: 80px;
  }

  .empty-block {
    height: 40vh;
  }

  .jobs-table {
    /* setup size */
    td, th {
      &:nth-of-type(1) {
        width: 8.695652173913043%;
      }
      &:nth-of-type(2) {        
        width: 21.739130434782609%;
      }
      &:nth-of-type(3) {
        width: 10.144927536231884%;
      }
      &:nth-of-type(4) {
        width: 13.043478260869565%;
      }
      &:nth-of-type(5) {
        width: 11.594202898550725%;
      }
      &:nth-of-type(6),
      &:nth-of-type(7),
      &:nth-of-type(8) {
        width: 11.594202898550725%;
      }
    }   
  }
`;

export default {
  CommunicationGoalsTable
};